import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { isMobile } from 'react-device-detect';
import { withTranslation } from 'react-i18next';
import { titleize } from 'underscore.string';

import EditButton from '../../../v2/buttons/EditButton';

import DriverAutocomplete from '../../drivers/DriverAutocomplete';

function getName(selectedDriver) {
  const { first_name, last_name } = selectedDriver;

  const firstName = (first_name || '').trim();
  const lastName = (last_name || '').trim();
  return `${firstName} ${lastName}`.trim();
}
class AssignDriver extends Component {
  constructor(props) {
    super(props);
    const { selectedDriver } = props;
    this.state = {
      assignToggled: false,
      selectedDriver,
      driverInput: '',
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { selectedDriver: currentSelectedDriver } = this.state;

    const { selectedDriver } = nextProps;

    if (selectedDriver._id !== currentSelectedDriver._id) {
      this.setState({
        selectedDriver: { ...selectedDriver },
        driverInput: '',
      });
    }
  }
  getDriverName() {
    return getName(this.props.selectedDriver);
  }
  getTitle() {
    const { isNewOffer, t } = this.props;
    if (isNewOffer) {
      return t('ASSIGN_DRIVER');
    }
    return t('RE_ASSIGN_DRIVER');
  }
  handleEditClick = (e) => {
    e.preventDefault();
    this.setState({
      assignToggled: true,
    });
  };

  handleCompleteAssign = () => {
    this.setState({
      assignToggled: false,
    });
    this.props.onCompleteAssignDriver({
      driverId: this.state.selectedDriver._id,
    });
  };

  handleCancelAssign = () => {
    const { onCancelAssignment, selectedDriver } = this.props;
    this.setState({
      driverInput: '',
      selectedDriver,
      assignToggled: false,
    });
    if (onCancelAssignment) {
      onCancelAssignment();
    }
  };
  render() {
    const { isCarrier, selectedDriver, t } = this.props;

    if (!isCarrier) {
      return null;
    }

    if (!selectedDriver._id) {
      return null;
    }
    return (
      <div className="driver-assignment">
        <h4>{this.getTitle()}</h4>
        {!this.state.assignToggled && (
          <div className="offer-info">
            <div className="text-sm flex space-x-1 items-center">
              <span>{this.getDriverName()}</span>
              <EditButton size="small" onClick={this.handleEditClick} />
            </div>
          </div>
        )}
        {this.state.assignToggled && (
          <div className={!isMobile ? 'offer-info' : null}>
            <DriverAutocomplete
              className="offer-field"
              drivers={this.props.drivers}
              value={this.state.driverInput}
              onDriverSelected={({ value, driver }) =>
                this.setState({
                  selectedDriver: driver,
                  driverInput: value,
                })
              }
              onChange={(driverInput) =>
                this.setState({
                  driverInput,
                })
              }
            />
            <div className="offer-field">
              <div className="flex justiy-end items-center space-x-2">
                <button
                  className="button button-green"
                  disabled={this.props.assignButtonDisabled}
                  onClick={this.handleCompleteAssign}
                >
                  {t('ASSIGN')}
                </button>
                <button
                  className="button button-secondary"
                  onClick={this.handleCancelAssign}
                >
                  {t('CANCEL')}
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

AssignDriver.propTypes = {
  isCarrier: PropTypes.bool,
  selectedDriver: PropTypes.shape({
    _id: PropTypes.string.isRequired,
    first_name: PropTypes.string.isRequired,
    last_name: PropTypes.string.isRequired,
  }),
  drivers: PropTypes.arrayOf(
    PropTypes.shape({
      _id: PropTypes.string.isRequired,
      fullName: PropTypes.string.isRequired,
      equipmentClassLabel: PropTypes.string.isRequired,
    }),
  ),
  onCancelAssignment: PropTypes.func,
  onCompleteAssignDriver: PropTypes.func.isRequired,
  isNewOffer: PropTypes.bool,
  assignButtonDisabled: PropTypes.bool,
};

AssignDriver.defaultProps = {
  isCarrier: false,
  drivers: [],
  selectedDriver: {},
  isNewOffer: true,
  assignButtonDisabled: false,
  onCancelAssignment: null,
};

export default withTranslation()(AssignDriver);
